/*
 * mh-batch-cart.js — Zweier-/Stückel-Schritt-Regel im Warenkorb & Cart-Drawer (myHarry)
 *
 * Zweck: Produkte mit custom.quantity_batch > 1 (z. B. Akustikpaneele Premium = 2)
 * dürfen auch im Warenkorb nur in Vielfachen des batch-Werts bestellt werden.
 *
 * Wirkungsweise (analog mh-sample-limit.js):
 *   1) Setzt step=batch auf die betroffenen Mengen-Inputs (saubere +/- Schritte).
 *   2) Snappt manuell eingetippte ungerade Werte auf das nächste Vielfache.
 *   3) Korrigiert nach jedem Cart-Update serverseitig ungerade Mengen via /cart/change.js
 *      (fängt auch Altbestände im Warenkorb und Umgehungen ab).
 *   4) Zeigt pro Position den Zeilenpreis (Stückpreis x Menge) statt des Stückpreises an,
 *      da der Drawer sonst den Preis fuer 1 Stueck darstellt.
 *
 * Die Erkennung läuft über data-quantity-variant-id im Cart-DOM gegen die unten
 * gepflegte Varianten->batch-Map. Map bei Änderung der Premium-Produkte aktualisieren.
 */
(function () {
  "use strict";

  // Varianten-ID (numerisch) -> batch. Aus custom.quantity_batch generiert.
  var BATCH = {
    53143614619976: 2,
    53143617274184: 2,
    53134213579080: 2,
    53134213873992: 2,
    53134214234440: 2,
    53134215381320: 2,
    53134215643464: 2,
    53134215807304: 2,
    53134216102216: 2,
    53142759014728: 2,
    53142785687880: 2,
    53142780379464: 2
  };

  if (window.__mhBatchCartBound) return;
  window.__mhBatchCartBound = true;

  var correcting = {};

  var eurFmt;
  try {
    eurFmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  } catch (e) {
    eurFmt = null;
  }
  function fmtEUR(cents) {
    var val = (cents || 0) / 100;
    if (eurFmt) return eurFmt.format(val);
    return val.toFixed(2).replace('.', ',') + ' €';
  }

  function batchForVariant(vid) {
    var b = BATCH[vid];
    return b && b > 1 ? b : 1;
  }

  // Rundet auf Vielfaches von batch; Gleichstand (x.5) wird abgerundet.
  // Bei vorhandener Position (v > 0) niemals unter batch.
  function correctQty(v, batch, allowZero) {
    if (isNaN(v) || v <= 0) return allowZero ? 0 : batch;
    var k = v / batch;
    var f = Math.floor(k);
    var c = (k - f > 0.5) ? (f + 1) * batch : f * batch;
    if (c < batch) c = batch;
    return c;
  }

  // step auf den betroffenen Inputs setzen
  function applyStepAttrs() {
    document.querySelectorAll('.quantity__input[data-quantity-variant-id]').forEach(function (input) {
      var vid = parseInt(input.getAttribute('data-quantity-variant-id'), 10);
      var batch = batchForVariant(vid);
      if (batch < 2) return;
      if (input.getAttribute('step') !== String(batch)) input.setAttribute('step', batch);
      input.setAttribute('data-mh-batch', batch);
    });
  }

  // Snapping bei manueller Eingabe (vor der Cart-AJAX-Logik, daher capture)
  function onChangeCapture(e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('.quantity__input[data-quantity-variant-id]')) return;
    var vid = parseInt(input.getAttribute('data-quantity-variant-id'), 10);
    var batch = batchForVariant(vid);
    if (batch < 2) return;
    var v = parseInt(input.value, 10);
    var c = correctQty(v, batch, true); // 0 erlauben (Entfernen)
    if (String(c) !== String(input.value)) {
      input.value = c;
    }
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  // Zeigt den Zeilenpreis (Stückpreis x Menge) statt des Stückpreises an.
  function fixLinePrices(cart) {
    if (!cart || !cart.items) return;
    cart.items.forEach(function (item, idx) {
      if (batchForVariant(item.variant_id) < 2) return;
      var line = idx + 1;
      document.querySelectorAll('.price[data-line-index="' + line + '"]').forEach(function (priceEl) {
        var finalEl = priceEl.querySelector('.price__sale, .price__regular');
        if (finalEl) {
          var fStr = fmtEUR(item.final_line_price);
          // Nur setzen wenn abweichend -> verhindert eine MutationObserver-Schleife.
          if (finalEl.textContent.trim() !== fStr) finalEl.textContent = fStr;
        }
        var strike = priceEl.querySelector('s');
        if (strike && item.original_line_price > item.final_line_price) {
          var sStr = fmtEUR(item.original_line_price);
          if (strike.textContent.trim() !== sStr) strike.textContent = sStr;
        }
      });
    });
  }

  // Serverseitige Korrektur ungerader Mengen
  function reconcile(cart) {
    if (!cart || !cart.items) return;
    cart.items.forEach(function (item, idx) {
      var batch = batchForVariant(item.variant_id);
      if (batch < 2) return;
      if (item.quantity % batch === 0) return;
      var line = idx + 1;
      if (correcting[line]) return;
      var corrected = correctQty(item.quantity, batch, false);
      if (corrected === item.quantity) return;
      correcting[line] = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: corrected })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
        })
        .finally(function () {
          setTimeout(function () { delete correcting[line]; }, 1000);
        });
    });
  }

  var t;
  function refresh() {
    applyStepAttrs();
    // Kein Batch-Produkt im Cart-UI sichtbar -> kein /cart.js-Abruf noetig.
    if (!document.querySelector('.quantity__input[data-mh-batch]')) return;
    clearTimeout(t);
    t = setTimeout(function () {
      getCart().then(function (cart) {
        reconcile(cart);
        fixLinePrices(cart);
      });
    }, 150);
  }

  // Synchroner Sofort-Fix der Zeilenpreise aus bereits vorhandenen Cart-Daten.
  // Wird direkt nach dem (Re-)Render des Drawers/der Cart-Section aufgerufen –
  // im selben Task wie das innerHTML-Update, also VOR dem Repaint. Dadurch wird
  // der Stückpreis nie sichtbar (kein Aufblitzen/Flash), auch bei aktivem Sale.
  // Kein zusaetzlicher /cart.js-Abruf noetig: das Event liefert final_line_price mit.
  function fixLinePricesSync(cart) {
    if (!cart || !cart.items) return;
    applyStepAttrs();
    fixLinePrices(cart);
  }

  document.addEventListener('change', onChangeCapture, true);
  // cart:updated wird von cart.js am Ende von onCartUpdate ausgeloest – das Drawer-
  // innerHTML steht dann bereits, und event.detail.cart enthaelt die Zeilenpreise.
  // -> Preise SOFORT (synchron) korrigieren, danach das asynchrone refresh() nur noch
  //    fuer die Mengen-Reconciliation (Vielfache von batch).
  document.addEventListener('cart:updated', function (e) {
    if (e && e.detail && e.detail.cart) {
      fixLinePricesSync(e.detail.cart);
    }
    refresh();
  });
  document.addEventListener('cart:refresh', refresh);
  document.addEventListener('product-ajax:added', refresh);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  // FoxTheme-PubSub (cartUpdate) – sobald verfügbar abonnieren.
  // Liefert das Event Cart-Daten mit, wird ebenfalls sofort (synchron) korrigiert,
  // sonst Fallback auf das asynchrone refresh().
  (function subPub(tries) {
    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe && FoxTheme.pubsub.PUB_SUB_EVENTS) {
      try {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (payload) {
          if (payload && payload.cart && payload.cart.items) {
            fixLinePricesSync(payload.cart);
          }
          refresh();
        });
      } catch (e) {}
    } else if (tries < 100) {
      setTimeout(function () { subPub(tries + 1); }, 100);
    }
  })(0);

  // Drawer/Section-Neuaufbau abfangen (debounced)
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () {
      clearTimeout(window.__mhBatchMoT);
      window.__mhBatchMoT = setTimeout(refresh, 200);
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
